/**
 * @flow
 * @relayHash 286c73e401451c3ff4120cea2dc7b629
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TacticalMeetingMetricsView_circle$ref = any;
export type TacticalMeetingMetricsQueryVariables = {|
  circleDatabaseId: string,
  orgDatabaseId: string,
|};
export type TacticalMeetingMetricsQueryResponse = {|
  +organization: ?{|
    +circle: ?{|
      +$fragmentRefs: TacticalMeetingMetricsView_circle$ref
    |}
  |}
|};
export type TacticalMeetingMetricsQuery = {|
  variables: TacticalMeetingMetricsQueryVariables,
  response: TacticalMeetingMetricsQueryResponse,
|};
*/


/*
query TacticalMeetingMetricsQuery(
  $circleDatabaseId: String!
  $orgDatabaseId: String!
) {
  organization(databaseId: $orgDatabaseId) {
    circle(databaseId: $circleDatabaseId) {
      ...TacticalMeetingMetricsView_circle
      id
    }
    id
  }
}

fragment TacticalMeetingMetricsView_circle on Circle {
  id
  databaseId
  organization {
    id
    databaseId
  }
  supportedRole {
    databaseId
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "circleDatabaseId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgDatabaseId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "orgDatabaseId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "databaseId",
    "variableName": "circleDatabaseId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TacticalMeetingMetricsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Circle",
            "kind": "LinkedField",
            "name": "circle",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TacticalMeetingMetricsView_circle"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TacticalMeetingMetricsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "Circle",
            "kind": "LinkedField",
            "name": "circle",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Role",
                "kind": "LinkedField",
                "name": "supportedRole",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "286c73e401451c3ff4120cea2dc7b629",
    "metadata": {},
    "name": "TacticalMeetingMetricsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5efdcfb35535e03cb86f1598a8ac1d61';

module.exports = node;
